<template>
  <div>
    <v-breadcrumbs :items="crumbs"></v-breadcrumbs>
    <base-loader :isLoading="isLoading"></base-loader>
    <v-row>
      <v-col md="6">
        <v-card>
          <v-card-text>
            <h4 class="text-md-h4 primary--text mb-5">
              {{ `${isEdit ? "Edit" : "New"} Team` }}
            </h4>
            <v-form ref="teamForm" @submit.prevent="save()">
              <v-row>
                <v-col md="12">
                  <v-text-field
                    v-model="teamModel.name"
                    label="Team Name"
                    required
                    outlined
                    :rules="[(v) => !!v || 'Team Name is required']"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-btn type="submit" color="success">Save</v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { gql } from "apollo-boost";
import { Team } from "@/models/Team";
export default {
  data() {
    return {
      isEdit: false,
      isLoading: false,
      teamModel: new Team(),
      me: "",
      search: null,
    };
  },
  created() {
    this.isEdit = this.$route.params.id != 0;
    this.isLoading = this.isEdit ? true : false;
  },
  computed: {
    crumbs() {
      return [
        {
          text: "Teams",
          disabled: false,
          href: "/admin/teams",
        },
        {
          text: "Team Detail",
          disabled: false,
          href: `/admin/teams/${this.$route.params.id}`,
        },
        {
          text: `${this.isEdit ? "Edit" : "New"} Team`,
          disabled: true,
        },
      ];
    },
  },
  watch: {},
  apollo: {
    me: gql`
      query {
        me {
          id
        }
      }
    `,
    team: {
      query: gql`
        query Team($id: ID!) {
          team(id: $id) {
            id
            name
          }
        }
      `,
      fetchPolicy: "network-only",
      skip() {
        return !this.isEdit;
      },
      variables() {
        const self = this;
        return {
          id: self.$route.params.id,
        };
      },
      result(response, key) {
        this.isLoading = false;
        this.teamModel.id = this.team.id;
        this.teamModel.name = this.team.name;
      },
    },
  },
  methods: {
    async save() {
      this.isLoading = true;
      const self = this;
      if (!self.$refs.teamForm.validate()) {
        self.$swal("Error", "Validation failed", "error");
        self.isLoading = false;
        return;
      }
      if (self.isEdit) {
        // update
        await this.updateTeam()
          .then(() => {
            this.$swal("Success!", "Team was updated", "success");
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              "something went wrong when trying to update the team, check data and try again later!",
              "error"
            );
          });
      } else {
        // create
        await this.createTeam()
          .then(() => {
            this.$swal("Success!", "Team was created", "success");
            window.location.href = `/admin/teams/${self.teamModel.id}/edit`;
          })
          .catch((e) => {
            this.$swal(
              "Error!",
              `Something went wrong when creating the team, check data and try again later!`,
              "error"
            );
          });
      }
      this.isLoading = false;
    },
    async updateTeam() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation update($team: TeamUpdateInput!) {
              updateTeam(team: $team) {
                id
                updated
              }
            }
          `,
          variables: {
            team: {
              id: self.teamModel.id,
              name: self.teamModel.name,
              createdBy: self.me.id,
            },
          },
        });
        if (!response) {
          throw "Something went wrong when creating the team!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
      } catch (e) {
        throw e.message;
      }
    },
    async createTeam() {
      const self = this;
      try {
        const response = await self.$apollo.mutate({
          mutation: gql`
            mutation createTeam($team: TeamCreateInput!) {
              createTeam(team: $team) {
                id
              }
            }
          `,
          variables: {
            team: {
              name: self.teamModel.name,
              createdBy: self.me.id,
            },
          },
        });

        if (!response) {
          throw "Something went wrong when creating the Team Item!";
        }
        if (response.errors && response.errors.length > 0) {
          throw response.errors[0];
        }
        if (response && response.data.createTeam) {
          self.teamModel.id = response?.data?.createTeam?.id;
        }
      } catch (e) {
        throw e.message;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
